/* In-collection search — Matraws.
   Lazily builds a client-side index of ALL products in the current collection
   (via /collections/<handle>/products.json), then filters by title as you type.
   Collection-scoped only — never site-wide. */
(function () {
  if (window.__mtwColSearch) return;
  window.__mtwColSearch = 1;

  var MAX_RESULTS = 100;     // cap rendered DOM nodes
  var PAGE_SIZE = 250;       // products.json max per page
  var MAX_PAGES = 60;        // safety cap (15.000 products)

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function init() {
    var root = document.querySelector('[data-collection-search]');
    if (!root) return;

    var handle = root.getAttribute('data-handle');
    var count = parseInt(root.getAttribute('data-count'), 10) || 0;
    // Forudbestilling (tag): præcis samme tekst som Liquid (snippets/mtw-forudbestilling, kun_tekst),
    // brugt uændret, så samme variant aldrig deles i to kurvlinjer.
    var poTekst = root.getAttribute('data-po-tekst') || 'Sendes, så snart varen udkommer';

    var input = root.querySelector('.mtw-colsearch__input');
    var clearBtn = root.querySelector('.mtw-colsearch__clear');
    var spinner = root.querySelector('.mtw-colsearch__spinner');
    var status = root.querySelector('[data-colsearch-status]');

    var parent = document.getElementById('CollectionProductsParent');
    if (!parent || !input) return;

    var origRow = parent.querySelector('[data-collection-products]');
    if (!origRow) return;
    var gridParent = origRow.parentNode;

    // Clone the real grid's classes so search results match the theme cards
    // (column sizing, white card box, padding) without hardcoding settings.
    var colClass = 'col-6 col-md-4 col-lg-4 col-xl-3';
    if (origRow.firstElementChild) {
      colClass = origRow.firstElementChild.className.replace(/^\s*\d+\s+/, '').trim() || colClass;
    }
    // Same structure/classes as snippets/product-card-grid.liquid ("Ens kort").
    var protoItem = origRow.querySelector('.product-card-item');
    var itemClass = protoItem ? protoItem.className.replace(/\s*\b(mtw-rh-item|sale-badge-percentage)\b/g, '').trim() : 'product-card-item';
    var protoCard = origRow.querySelector('.product-card');
    var cardClass = protoCard ? protoCard.className : 'product-card mtw-pc product-background-enabled';
    var protoDetail = origRow.querySelector('.product-card-detail');
    var detailClass = protoDetail ? protoDetail.className : 'product-card-detail text-left';
    var protoTitle = origRow.querySelector('.product-title');
    var titleClass = protoTitle ? protoTitle.className : 'product-title text title-truncate';
    var protoPrice = origRow.querySelector('.mtw-pc-row .product-price');
    var priceClass = protoPrice ? protoPrice.className : 'product-price text';

    var resultsRow = document.createElement('div');
    resultsRow.className = 'row mtw-colsearch-results';
    resultsRow.hidden = true;
    gridParent.appendChild(resultsRow);

    // Spejler money_without_trailing_zeros: "6 kr", "1.299 kr", øre kun når de findes ("12,50 kr").
    function money(n) {
      var cents = Math.round(n * 100);
      var kr = Math.floor(cents / 100), ore = cents % 100;
      var out = String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (ore) out += ',' + (ore < 10 ? '0' : '') + ore;
      return out + ' kr';
    }

    var index = null;     // [{t, tl, s, u, img, name, num, rar, lang, p, cmp, from, vid, av, one}]
    var loading = false;
    var loadPromise = null;
    var cacheKey = 'mtwcs7:' + handle + ':' + count;  // mtwcs7: + kommer snart (ks) -> gamle cachede indekser skal smides vaek
    var hiddenEls = [];

    function setStatus(html) {
      if (!status) return;
      if (html) { status.innerHTML = html; status.hidden = false; }
      else { status.hidden = true; status.innerHTML = ''; }
    }

    function fromCache() {
      try {
        var raw = sessionStorage.getItem(cacheKey);
        return raw ? JSON.parse(raw) : null;
      } catch (e) { return null; }
    }
    function toCache(arr) {
      try { sessionStorage.setItem(cacheKey, JSON.stringify(arr)); } catch (e) {}
    }

    // Enkeltkort "Navn - Sæt (Raritet) [Nr]" -> navn + "#nr · raritet" (som product-card-grid.liquid).
    // Kun når produkttypen indeholder "Single"; ellers vises den fulde titel.
    function parseTitle(title, type) {
      var none = { name: '', num: '', rar: '' };
      if (String(type || '').toLowerCase().indexOf('single') === -1) return none;
      var t = String(title || '').replace(/[\u2063\u200B]/g, '').trim();
      var rest = t, num = '';
      if (t.slice(-1) === ']' && t.indexOf(' [') > -1) {
        num = t.slice(t.lastIndexOf('[') + 1).replace(/\]/g, '').trim();
        rest = t.slice(0, t.lastIndexOf('[')).trim();
      }
      if (rest.slice(-1) !== ')' || rest.indexOf(' - ') === -1) return none;
      var cut = rest.lastIndexOf('(');
      var rar = rest.slice(cut + 1).replace(/\)/g, '').trim();
      rest = rest.slice(0, cut).trim();
      var name = rest.split(' - ')[0].trim();
      var set = rest.slice(name.length).replace(' - ', '').trim();
      // One Piece: "Kaido (OP17-063) (V.1)" -> "Kaido (V.1)"; koden står allerede i meta
      if (num) name = name.split('(' + num + ')').join('').replace(/  /g, ' ').trim();
      if (!name || !set || !rar) return none;
      return { name: name, num: num, rar: rar };
    }

    function mapProduct(p) {
      var img = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';
      // Samme størrelse som gitterets kort (360 px ligger i Shopifys CDN-cache)
      if (img) {
        img = img.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
        img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=360';
      }
      // Prisen regnes på varianter PÅ LAGER og uden Reverse Holo (RH har sit eget kort i griddet);
      // kun hvis RH er det eneste på lager, bruges RH. Kurv/quick view bruger gruppens billigste
      // variant. Spejler snippets/price.liquid; udsolgt produkt falder tilbage til laveste pris.
      var opts = p.options || [];
      var edKey = null;
      for (var o = 0; o < opts.length; o++) {
        if (String(opts[o].name || '').toLowerCase() === 'edition') { edKey = 'option' + (opts[o].position || o + 1); break; }
      }
      var groups = { n: { min: null, max: null, count: 0, vid: null, cmp: 0 }, r: { min: null, max: null, count: 0, vid: null, cmp: 0 } };
      var anyMin = null;
      var vars = p.variants || [];
      for (var i = 0; i < vars.length; i++) {
        var v = parseFloat(vars[i].price);
        if (isNaN(v)) continue;
        if (anyMin === null || v < anyMin) anyMin = v;
        if (!vars[i].available) continue;
        var isRH = edKey && String(vars[i][edKey] || '').toLowerCase().indexOf('reverse') > -1;
        var g = isRH ? groups.r : groups.n;
        g.count++;
        if (g.min === null || v < g.min) { g.min = v; g.vid = vars[i].id; g.cmp = parseFloat(vars[i].compare_at_price) || 0; }
        if (g.max === null || v > g.max) g.max = v;
      }
      var grp = groups.n.count ? groups.n : groups.r;
      var av = grp.count > 0;
      var price = av ? grp.min : anyMin;
      var vid = av ? grp.vid : (vars.length ? vars[0].id : null);
      // Produktsiden åbner på den billigste på lager. Er det RH, skal normalkortet selv forvælge sin variant, så prisen passer
      var rhBilligere = groups.n.count > 0 && groups.r.count > 0 && groups.r.min < groups.n.min;
      var tagList = p.tags || [];
      if (typeof tagList === 'string') tagList = tagList.split(/\s*,\s*/);
      var lang = '';
      if (tagList.indexOf('Japanese') > -1) lang = 'JP';
      else if (tagList.indexOf('Chinese') > -1 || tagList.indexOf('Simplified Chinese') > -1) lang = 'CN';
      else if (tagList.indexOf('Korean') > -1) lang = 'KR';
      var pt = parseTitle(p.title, p.product_type);
      var search = ((p.title || '') + ' ' + tagList.join(' ')).toLowerCase();
      return {
        t: p.title, tl: (p.title || '').toLowerCase(), s: search, u: '/products/' + p.handle, img: img,
        name: pt.name, num: pt.num, rar: pt.rar, lang: lang,
        p: price, cmp: av ? grp.cmp : 0, from: grp.count > 1 && grp.max > grp.min,
        vid: vid, rhBilligere: rhBilligere, av: av, one: vars.length === 1 && vars[0].title === 'Default Title',
        // Kommer snart (tag Kommer-snart) vinder over Forudbestilling: pris, men ingen kurv-knap
        ks: tagList.indexOf('Kommer-snart') > -1,
        po: tagList.indexOf('Forudbestilling') > -1 && tagList.indexOf('Kommer-snart') < 0
      };
    }

    function loadAll() {
      if (index) return Promise.resolve(index);
      if (loadPromise) return loadPromise;

      var cached = fromCache();
      if (cached && cached.length) { index = cached; return Promise.resolve(index); }

      loading = true;
      if (spinner) spinner.hidden = false;
      var acc = [];

      function fetchPage(page) {
        var url = '/collections/' + handle + '/products.json?limit=' + PAGE_SIZE + '&page=' + page;
        return fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (data) {
            var prods = (data && data.products) || [];
            for (var i = 0; i < prods.length; i++) acc.push(mapProduct(prods[i]));
            setStatus('Indlæser kollektionen… <b>' + acc.length + '</b> kort');
            if (prods.length === PAGE_SIZE && page < MAX_PAGES) return fetchPage(page + 1);
            return acc;
          });
      }

      loadPromise = fetchPage(1).then(function (arr) {
        index = arr;
        loading = false;
        if (spinner) spinner.hidden = true;
        toCache(arr);
        if (!input.value.trim()) setStatus('');   // clear the "Indlæser…" line once loaded & idle
        return index;
      }).catch(function () {
        loading = false;
        if (spinner) spinner.hidden = true;
        setStatus('Kunne ikke indlæse kollektionen til søgning.');
        return [];
      });
      return loadPromise;
    }

    function escapeHTML(s) {
      return (s || '').replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    var CART_SVG = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="9" cy="20" r="1.6" fill="currentColor"/><circle cx="18" cy="20" r="1.6" fill="currentColor"/><path d="M2 3h2.2l2.1 11.2a1.4 1.4 0 0 0 1.4 1.1h8.9a1.4 1.4 0 0 0 1.4-1.1L20 7H5.2" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var BELL_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M10 19a2 2 0 0 0 4 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

    // Samme kort som snippets/product-card-grid.liquid: billedbrønd, navn + meta, pris-række med én handling.
    function cardHTML(item) {
      var u = escapeHTML(item.u), t = escapeHTML(item.t);
      var uKort = item.rhBilligere ? u + '?variant=' + item.vid : u;
      var single = !!item.name;
      var imgTag = item.img
        ? '<img class="product-image" src="' + escapeHTML(item.img) + '" alt="" loading="lazy" width="300" height="300">'
        : '';
      var title = single
        ? '<span aria-hidden="true">' + escapeHTML(item.name) + '</span><span class="mtw-vh">' + t + '</span>'
        : t;
      var meta = '';
      if (single || item.lang) {
        meta = '<p class="mtw-pc-meta"' + (single ? ' aria-hidden="true"' : '') + '>' +
          (single
            ? (item.num ? '<span class="mtw-pc-num">#' + escapeHTML(item.num) + '</span><span class="mtw-pc-dot">&nbsp;·&nbsp;</span>' : '') +
              '<span class="mtw-pc-rar">' + escapeHTML(item.rar) + '</span>'
            : '') +
          (item.lang ? '<span class="mtw-pc-lang">' + item.lang + '</span>' : '') +
        '</p>';
      }
      var price = '';
      if (item.p !== null && item.p !== undefined) {
        price = '<div class="' + priceClass + '">' +
          (item.from
            ? '<span class="price-item actual-price price-varies">Fra ' + money(item.p) + '</span>'
            : '<span class="price-item actual-price">' + money(item.p) + '</span>') +
          (item.cmp > item.p ? '<span class="price-item compare-price">' + money(item.cmp) + '</span>' : '') +
        '</div>';
      }
      var act;
      if (item.ks) {
        act = '<div class="mtw-acts mtw-acts--notify"><a class="mtw-act mtw-act--notify" href="' + u + '" aria-label="Giv mig besked når ' + t + ' kommer">' +
          BELL_SVG + '<span class="mtw-act-label">Giv mig besked</span></a></div>';
      } else if (!item.av || !item.vid) {
        act = '<div class="mtw-acts mtw-acts--notify"><a class="mtw-act mtw-act--notify" href="' + u + '" aria-label="Giv mig besked når ' + t + ' er på lager igen">' +
          BELL_SVG + '<span class="mtw-act-label">Giv mig besked</span></a></div>';
      } else if (item.one) {
        act = '<div class="mtw-acts"><product-form class="mtw-act-form">' +
          '<form method="post" action="/cart/add" enctype="multipart/form-data" data-type="add-to-cart-form">' +
            '<input type="hidden" name="id" value="' + item.vid + '">' +
            '<input type="hidden" name="quantity" value="1">' +
            (item.po ? '<input type="hidden" name="properties[Forudbestilling]" value="' + escapeHTML(poTekst) + '">' : '') +
            '<button type="submit" class="mtw-act mtw-act--cart" aria-label="' + (item.po ? 'Forudbestil ' + t : 'Læg ' + t + ' i kurven') + '">' + CART_SVG + '</button>' +
          '</form></product-form></div>';
      } else {
        // Flere varianter (fx stand) -> quick view; ?variant= forvælger den viste (billigste) variant
        act = '<div class="mtw-acts"><a class="mtw-act mtw-act--cart" href="' + u + '?variant=' + item.vid + '" data-quick-view aria-label="Vælg variant for ' + t + '">' +
          CART_SVG + '</a></div>';
      }
      return '<div class="' + colClass + '">' +
        '<div class="' + itemClass + '" data-product-grid data-mtw-available="' + (item.av ? 'true' : 'false') + '">' +
        '<div class="' + cardClass + '">' +
          '<div class="product-card-img">' +
            (item.av || item.ks ? '' : '<span class="mtw-soldout" aria-hidden="true">UDSOLGT</span>') +
            (item.ks ? '<div class="product-card-badges"><span class="product-badge preorder-badge" style="background:#1a1a1a;color:#FFCB03;">Kommer snart</span></div>' : '') +
            (item.po && item.av ? '<div class="product-card-badges"><span class="product-badge preorder-badge">Forudbestilling</span></div>' : '') +
            '<a class="product-img" href="' + uKort + '" tabindex="-1" title="' + t + '">' +
              '<div class="media" style="--imageRatio:100%">' + imgTag + '</div>' +
            '</a>' +
          '</div>' +
          '<div class="' + detailClass + '">' +
            '<a href="' + uKort + '" class="' + titleClass + '"' + (single ? ' title="' + t + '"' : '') + '>' + title + '</a>' +
            meta +
            '<div class="mtw-pc-row">' + price + act + '</div>' +
          '</div>' +
        '</div></div></div>';
    }

    // Hide everything else in the grid container while searching (incl. anything
    // injected by third-party apps), and restore it exactly afterwards.
    function hideOthers() {
      var kids = gridParent.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (el === resultsRow || el.__mtwHidden) continue;
        el.__mtwHidden = true;
        el.__mtwPrevDisplay = el.style.display;
        el.style.display = 'none';
        hiddenEls.push(el);
      }
    }
    function showOthers() {
      for (var i = 0; i < hiddenEls.length; i++) {
        hiddenEls[i].style.display = hiddenEls[i].__mtwPrevDisplay || '';
        hiddenEls[i].__mtwHidden = false;
      }
      hiddenEls = [];
    }

    function showOriginal() {
      resultsRow.hidden = true;
      resultsRow.innerHTML = '';
      showOthers();
      setStatus('');
    }

    // Efter en AJAX-filtrering erstatter temaet grid-containeren, så vores
    // resultsRow/gridParent-referencer bliver forældede. Re-find dem her.
    function ensureRow() {
      if (resultsRow && document.body.contains(resultsRow)) return true;
      var p = document.getElementById('CollectionProductsParent');
      var row = p && p.querySelector('[data-collection-products]');
      if (!row) return false;
      gridParent = row.parentNode;
      if (!resultsRow || !document.body.contains(resultsRow)) {
        resultsRow = document.createElement('div');
        resultsRow.className = 'row mtw-colsearch-results';
        resultsRow.hidden = true;
      }
      gridParent.appendChild(resultsRow);
      hiddenEls = [];
      return true;
    }

    function runSearch(q) {
      q = (q || '').trim().toLowerCase();
      if (!q) { showOriginal(); return; }
      if (!ensureRow()) return;

      var tokens = q.split(/\s+/);
      var matches = [];
      for (var i = 0; i < index.length; i++) {
        var s = index[i].s || index[i].tl || '', ok = true;
        for (var k = 0; k < tokens.length; k++) {
          if (s.indexOf(tokens[k]) === -1) { ok = false; break; }
        }
        if (ok) { matches.push(index[i]); if (matches.length > 5000) break; }
      }

      hideOthers();

      if (!matches.length) {
        resultsRow.hidden = true;
        resultsRow.innerHTML = '';
        setStatus('<div class="mtw-colsearch-empty"><strong>Ingen kort matchede "' + escapeHTML(q) + '"</strong>Prøv et andet søgeord eller ryd søgningen.</div>');
        return;
      }

      var shown = matches.slice(0, MAX_RESULTS);
      var html = '';
      for (var m = 0; m < shown.length; m++) html += cardHTML(shown[m]);
      resultsRow.innerHTML = html;
      resultsRow.hidden = false;
      if (typeof window.quickviewElements === 'function') window.quickviewElements(resultsRow);

      if (matches.length > MAX_RESULTS) {
        setStatus('Viser de første <b>' + MAX_RESULTS + '</b> af <b>' + matches.length + '</b> kort — forfin din søgning.');
      } else {
        setStatus('<b>' + matches.length + '</b> ' + (matches.length === 1 ? 'kort matcher' : 'kort matcher') + ' "' + escapeHTML(q) + '"');
      }
    }

    var debouncedSearch = debounce(function (val) {
      if (!index) {
        loadAll().then(function () { runSearch(val); });
      } else {
        runSearch(val);
      }
    }, 130);

    // Warm the index as soon as the user engages the field
    input.addEventListener('focus', function () { loadAll(); }, { once: true });

    input.addEventListener('input', function () {
      var val = input.value;
      if (clearBtn) clearBtn.hidden = !val;
      if (!val.trim()) { showOriginal(); return; }
      if (!index && !loading) setStatus('Indlæser kollektionen…');
      debouncedSearch(val);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        showOriginal();
        input.focus();
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
